var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"nav"},[_c('Nav',{attrs:{"title":"使用指南","fixed":true}}),_c('div',{staticClass:"top"})],1),_c('div',{staticClass:"img"},[_c('van-image',{attrs:{"src":_vm.$global.account_url+_vm.url}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }